import React from 'react';
import './style.css';
import AuraButtonGreen from '../AuraButton/AuraButtonGreen';

const AuraSecondCta = () => {
    const feeRunsData = [
        {
            status: 'Reached End of Period',
            statusType: 'completed',
            period: 'Fortnight ending 20 July 2025',
            incomeBasis: 'Fortnightly',
            engagementMethod: 'Independent Practitioner',
            receipted: '$ 211,794.90'
        },
        {
            status: 'Reached End of Period',
            statusType: 'completed',
            period: 'Week ending 20 July 2025',
            incomeBasis: 'Weekly',
            engagementMethod: 'Independent Practitioner',
            receipted: '$ 201,794.90'
        },
        {
            status: 'In Period',
            statusType: 'active',
            period: 'Month ending 31 July 2025',
            incomeBasis: 'Monthly',
            engagementMethod: 'Employed Practitioner',
            receipted: '$ 200,594.70'
        },
        {
            status: 'In Period',
            statusType: 'active',
            period: 'Month ending 31 July 2025',
            incomeBasis: 'Monthly',
            engagementMethod: 'LOCUM',
            receipted: '$ 199,624.30'
        }
    ];

    return (
        <section className="aura-second-cta-section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-5">
                        <div className="aura-second-cta-content">
                            <h2 className="aura-second-cta-heading">Calculate</h2>
                            <p className="description-text mt-0 mb-4">
                                For years practices have been looking for a simple, accurate way to calculate practice service fees. We're excited to announce it's finally here.
                            </p>
                            <AuraButtonGreen text='Learn more' link='#' />
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="aura-fee-runs-card">
                            <h3 className="aura-fee-runs-title">Current Fee Runs</h3>
                            <div className="aura-fee-runs-table-wrapper">
                                <table className="aura-fee-runs-table">
                                    <thead>
                                        <tr>
                                            <th>Status</th>
                                            <th>Period</th>
                                            <th>Income Basis</th>
                                            <th>Engagement Method</th>
                                            <th>Receipted (Excl GST)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {feeRunsData.map((row, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <span className={`aura-status-badge aura-status-${row.statusType}`}>
                                                        {row.status}
                                                    </span>
                                                </td>
                                                <td>{row.period}</td>
                                                <td>{row.incomeBasis}</td>
                                                <td>{row.engagementMethod}</td>
                                                <td className="aura-receipted-amount">{row.receipted}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AuraSecondCta;
